module.exports = __webpack_public_path__ + "img/00011.8164beaf.webp";